// removed by extract-text-webpack-plugin
module.exports = {"unit":"5px","caption":"fonts__caption____HpZ4e","body":"fonts__body____3cWGm","oldColorBlack":"#4a4a4a","oldColorWarmGray":"#bebbc8","oldColorViolet":"#652c91","checkItem":"radio-item__checkItem____P3-5A","checkItemLabel":"radio-item__checkItemLabel____1MxiE fonts__body____3cWGm","selected":"radio-item__selected____2MzkJ","disabled":"radio-item__disabled____1_L4A","outlined":"radio-item__outlined____36Wpk","hintText":"radio-item__hintText____1a8Qe fonts__caption____HpZ4e"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/widgets/radio-item/radio-item.css
// module id = 268
// module chunks = 0